<div class="container-inco">
  <div class="header-container">
    <div class="header-left">
      <h2>{{title}}</h2>
    </div>
  </div>

  <table mat-table [dataSource]="projectsData" class="mat-elevation-z8 mat-table-custom inco-master-table" id="focusProjectList">
    <ng-container matColumnDef="projectId">
      <th mat-header-cell *matHeaderCellDef class="text-left">Project ID</th>
    <td mat-cell *matCellDef="let project" class="text-left">
      <p [innerHTML]="project.id"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="projectTitle">
    <th mat-header-cell *matHeaderCellDef class="text-left long-text-col">Project Title</th>
    <td mat-cell *matCellDef="let project" class="text-left long-text-col">
      <p [innerHTML]="project.projectTitle || '-'" [matTooltip]="project.projectTitle"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="projectResponsible">
    <th mat-header-cell *matHeaderCellDef class="text-left long-text-col">Point of contact</th>
    <td mat-cell *matCellDef="let project" class="text-left long-text-col">
      <p [innerHTML]="project.responsibleUser || '-'" [matTooltip]="project.responsibleUser"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="maintenance">
    <th mat-header-cell *matHeaderCellDef>Maintenance %</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="project.maintenance || '-'"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="expansion">
    <th mat-header-cell *matHeaderCellDef>Expansion %</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="project.expansion || '-'"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="focus">
    <th mat-header-cell *matHeaderCellDef>Focus Project</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.focus)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="phase">
    <th mat-header-cell *matHeaderCellDef class="text-left">Phase</th>
    <td mat-cell *matCellDef="let project" class="text-left nowrap-col">
      <p [innerHTML]="getPhaseLabel(project.phaseId)"></p>
    </td>
  </ng-container>
  <!-- <ng-container matColumnDef="changeLog">
    <th mat-header-cell *matHeaderCellDef>Change Log</th>
    <td mat-cell *matCellDef="let project">
      <button mat-icon-button class="branch-excellence-changelog-button" matTooltip="Change Log" style="width:100%"
        (click)="viewprojectHistory(project)">
        <mat-icon>history</mat-icon>
      </button>
    </td>
  </ng-container> -->

  <tr mat-header-row class="tableheader" *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let project; columns: displayedColumns;" class="table-row">
  </tr>
</table>